import { InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import React from "react";
import { NoAnnotationsIllustration } from "~/areas/infrastructure/components/ArgoCDInstances/components/NoAnnotationsIllustration";
import { ExternalLinkSlugs } from "../ArgoCDConstants";
type EmptyStateNoAnnotationsProps = {
    onGenerateAnnotationsClick: () => void;
};
export const EmptyStateNoAnnotations = (props: EmptyStateNoAnnotationsProps) => (<InlineEmptyStateOnboarding illustration={"Custom"} image={<NoAnnotationsIllustration />} title={"This application doesn't have any annotations yet"} description={"Start by adding annotations to this Argo CD application to map it to Octopus projects, environments and tenants"} actions={{
        primary: {
            type: "button",
            label: "Generate annotations",
            onClick: props.onGenerateAnnotationsClick,
        },
    }} learnMore={{
        label: "Docs: Argo CD",
        path: ExternalLinkSlugs.AnnotationsDocs,
    }}/>);
